import React from 'react';
import { lazyWithRetry } from '../../utils/lazyWithRetry';
import { AppRoute } from '../routes.types';
import KnowledgeBaseContentLibrary from '../../containers/KnowledgeBase/KnowledgeBaseContentLibrary/KnowledgeBaseContentLibrary';
import PocPage from '../../clubhouse/poc-page/poc-page';
import { DataRequestDashboardPage } from '../../containers/DataRequest/DataRequestDashboardPage/DataRequestDashboardPage';
const GrowPage = lazyWithRetry(() => import('../../venues/pages/GrowPage/GrowPage'));
const MyPractices = lazyWithRetry(() => import('../../containers/Practices/MyPractices'));
const Practice = lazyWithRetry(() => import('../../containers/Practices/Practice'));
const PracticeManagement = lazyWithRetry(() => import('../../containers/PracticeManagementGroups/PracticeManagement'));
const PracticeManagementPMG = lazyWithRetry(() => import('../../containers/PracticeManagementGroups/PracticeManagementPMG/PracticeManagementPMG'));
const MyGroupsAdminComponant = lazyWithRetry(() => import('../../containers/MyGroups/MyGroups'));
const PracticeValuationReports = lazyWithRetry(() => import('../../containers/PracticeValuationReports/PracticeValuationReports'));

export const GROW_ROUTES: AppRoute[] = [
    { path: '', element: <GrowPage /> },
    { path: 'practices', element: <MyPractices /> },
    { path: 'practices/:id', element: <Practice /> },
    { path: 'knowledge-library', element: <KnowledgeBaseContentLibrary />, withAppShell: true },
    { path: 'practice-management-groups', element: <PracticeManagement /> },
    { path: 'practice-management-pmg/:id', element: <PracticeManagementPMG /> },
    { path: 'my-groups', element: <MyGroupsAdminComponant /> },
    { path: 'ipoc', element: <PocPage />, withAppShell: true },
    { path: 'cpoc/:id', element: <PocPage />, withAppShell: true },
    { path: 'practice-valuation-reports', element: <PracticeValuationReports /> },
    { path: 'data-request-dashboard', element: <DataRequestDashboardPage /> },
    { path: 'data-request-dashboard/others', element: <DataRequestDashboardPage /> },
];
